import axios from 'axios';
import Configs from './Shared/Config';
import { ToastService } from './Shared/Alert';
import Store from './Redux/Store';
import { logOut } from './Redux/Reducers/SuperAdminAuth.Reducer';
import { logOut as companyLogOut } from './Redux/Reducers/CompanyAuth.Reducer';

import { loading } from './Redux/Reducers/Ui.Reducer';

axios.defaults.baseURL = Configs.API_URL;
axios.interceptors.request.use(
   (config) => {
      Store.dispatch(loading(true));
      return config;
   },
   (error) => {
      return Promise.reject(error);
   }
);

axios.interceptors.response.use(
   (resp) => {
      if ((resp?.data?.status === 200 || resp?.data?.status === 201) && resp?.data?.message) {
         ToastService.success(resp.data.message);
      }
      if (resp?.data?.status === 205 && resp?.data?.message) {
         ToastService.warning(resp.data.message);
      }
      Store.dispatch(loading(false));
      return resp;
   },
   async (error) => {
      if (error && error.response) {
         const { data, status, config } = error.response;
         if (status === 401) {
            // Store.dispatch(logOut());

            if(config.baseURL == `${process.env.MIX_APP_URL}/api`) {
                Store.dispatch(logOut());
            }else{
                Store.dispatch(companyLogOut());
            }
            // CompanyAuthService.refreshToken().then((resp) => {
            //     console.log('token issue', resp)
            //       if (resp.status === 200) {
            //          Store.dispatch(refreshToken(resp.data.access_token));
            //       }
            //    }).catch((err) => {

            // })
         } else if (config?.suppressErrorToast) {
            // Opt-in per-request escape hatch (see ShiftManagementService's
            // shiftAdd/editShift) for a caller that wants to map a specific
            // backend validation message to an inline field error instead
            // of this global toast — the caller's own catch() is then
            // responsible for still toasting any OTHER error it doesn't
            // recognize, so unrelated errors keep behaving exactly as
            // before. Doesn't affect 401 above, which isn't a toast.
         } else if (status === 500) {
            ToastService.error(data.message);
         } else if (status === 422 && data.message) {
            ToastService.warning(data.message);
         } else if (status === 422 && data.messages.email) {
            ToastService.warning(data.messages.email);
         } else if (status === 422 && data.messages.name) {
            ToastService.warning(data.messages.name);
         } else if (status === 403 && data.message) {
            ToastService.warning(data.message);
         } else if (status === 404 && data.message) {
            ToastService.warning(data.message);
         } else if (status === 400 && data.message) {
            ToastService.error(data.message);
         }
      }
      Store.dispatch(loading(false));
      return Promise.reject(error);
   }
);

export const Http = axios;
export const FixedHttp = axios.create();
